const subUsersValidationNL = {
    "add": {
        "first_name": {
            "required": "Voornaam is verplicht"
        },
        "last_name": {
            "required": "Achternaam is verplicht"
        },
        "email": {
            "required": "E-mail is verplicht",
            "invalid": "E-mail is niet geldig",
            "unique": "E-mail is gekoppeld aan een andere gebruiker"
        },
        "username": {
            "required": "Gebruikersnaam is verplicht",
            "stringCaseLower": "Gebruikersnaam moet in kleine letters zijn",
            "regexp": "Gebruikersnaam mag alleen uit letters en cijfers bestaan",
            "unique": "Gebruikersnaam is gekoppeld aan een andere gebruiker",
            "invalid": "Gebruikersnaam is niet geldig"
        },
        "password": {
            "required": "Wachtwoord is verplicht",
            "regexp": "Wachtwoord moet uit minimaal 10 tekens bestaan, inclusief 1 hoofdletter en 1 speciaal teken"
        },
        "confirmPassword": {
            "required": "Bevestig wachtwoord",
            "identical": "Wachtwoord en bevestig wachtwoord moeten overeenkomen"
        },
        "contract_expiry": {
            "required": "Contractvervaldatum is verplicht"
        },
        "sub_user_deal": {
            "required": "Subgebruiker deal is verplicht",
            "between": "Subgebruiker deal moet tussen 0 en 100 zijn"
        },
        "street_and_number": {
            "required": "Straat en huisnummer zijn verplicht"
        },
        "postal_code": {
            "required": "Postcode is verplicht"
        },
        "city": {
            "required": "Stad is verplicht"
        },
        "country": {
            "required": "Land is verplicht"
        },
        "phone": {
            "required": "Telefoonnummer is verplicht"
        }
    },
    "update": {
        "first_name": {
            "required": "Voornaam is verplicht"
        },
        "last_name": {
            "required": "Achternaam is verplicht"
        },
        "email": {
            "required": "E-mail is verplicht",
            "invalid": "E-mail is niet geldig"
        },
        "username": {
            "required": "Gebruikersnaam is verplicht",
            "stringCaseLower": "Gebruikersnaam moet in kleine letters zijn",
            "regexp": "Gebruikersnaam mag alleen uit letters en cijfers bestaan"
        },
        "contract_expiry": {
            "required": "Contractvervaldatum is verplicht"
        },
        "sub_user_deal": {
            "required": "Subgebruiker deal is verplicht",
            "between": "Subgebruiker deal moet tussen 0 en 100 zijn"
        },
        "street_and_number": {
            "required": "Straat en huisnummer zijn verplicht"
        },
        "postal_code": {
            "required": "Postcode is verplicht"
        },
        "city": {
            "required": "Stad is verplicht"
        },
        "country": {
            "required": "Land is verplicht"
        },
        "phone": {
            "required": "Telefoonnummer is verplicht"
        }
    }
};

export default subUsersValidationNL;